<template>
  <div>
    <el-card>
      <el-alert
    title="企业标签"
    type="warning"
    description="仅供浏览!"
    show-icon>
  </el-alert>
    </el-card>
    <el-card :gutter="20">
      <el-row :gutter="20">
        <el-col :md="8" :lg="4">
            <el-select size="small" v-model="params.corp_id" clearable placeholder="切换企业" @change="typesearch">
                <el-option v-for="item in corpList" :key="item.id" :label="item.title" size="mini" :value="item.id"> </el-option>
            </el-select>
        </el-col>
      </el-row>
   </el-card>
   <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <!-- <el-form-item prop="group_name" label="所属门店">
              <el-tag :key="item.wxShopId" class="new-tag" v-for="(item,index) in rel_shops_ids" closable :disable-transitions="false" @close="storeHandleClose(index)"> {{item.storeName}}
              </el-tag>
      </el-form-item> -->
      <el-table-column prop="group_name" label="标签组" width="150"></el-table-column>
      <el-table-column prop="taglist" label="标签">
            <template slot-scope="scope">
              <el-tag type="danger" v-for="taglist in scope.row.taglist" :key="taglist.index" :color="taglist.tag_color" size="mini" :style="'color:'+ taglist.font_color" style="display: inline-block; margin-right:3px;">{{taglist.name}}</el-tag>
            </template>
      </el-table-column>
    </el-table>
     <!-- <div class="content-center content-top-padded">
          <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[10,20,50]"
                  :total="total_count"
                  :page-size="params.pageSize">
          </el-pagination>
      </div> -->
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getTaglist ,getCropList} from '../../api/workwx'
  export default {
    data () {
      return {  
        total_count: 0,
        editVisible:false,
        submitLoading:false,
        editTitle: '',
        params: {
          page: 1,
          pageSize: 20,
          corp_id:'',
        },
        catesList:[],
        corpList:[],
        loading:false,
        memberTagDialog: false,
        tagList:[],
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      // 获取企业列表
      getCropList(){    
        getCropList(this.params).then(res => {
          this.corpList = res.data.data.list
          this.params.corp_id = this.corpList[0].id
          this.getDataList()
          })
      },
      typesearch () {
        this.params.page = 1
        this.getDataList()
      },
      handleSizeChange (pageSize) {
          this.params.page = 1
          this.params.pageSize = pageSize
          
      },
      handleEdit(){
        this.editVisible = false
        this.editTitle = ""
      },
      getDataList () {
        this.loading = true
        getTaglist({'corp_id':this.params.corp_id}).then(response => {
            this.catesList = response.data.data
            // this.total_count = response.data.data.total_count
            this.loading = false
          }).catch(error => {
            this.loading = false
            this.$message({
              type: 'error',
              message: '获取列表信息出错'
            })
          })
      },
    },
    mounted () {
      this.getCropList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>


// WEBPACK FOOTER //
// tag.vue?6e34f146